import { OperatorFunction, map } from 'rxjs';

// Slice array, takes top count elements
export function sliceArray<T>(count: number): OperatorFunction<ReadonlyArray<T>, Array<T>> {
  return map((items) => (items || []).slice(0, count));
}

export function isStringArray(arr: unknown): arr is Array<string> {
  if (!Array.isArray(arr)) {
    return false;
  }
  return arr.every((e) => typeof e === 'string');
}
